export default class Profile {
    constructor(projectId) {
        this.id = null
        this.projectId = projectId
        this.title = null
    }
}
